var _style, _defs, _ellipse, _g, _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use10, _use11, _use12, _use13, _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrontierswomansLeague(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-3.6 -4.5 7.2 9.2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlLang: "en",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .ivory {\n      fill: #fcf5cd;\n      stroke: #d8b37b;\n    }\n  ")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "cameo-edge"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "90%",
    stopColor: "black"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2e2e2e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "star",
    fill: "#fff",
    d: "         M0 -0.2         q0 0.2 0.2 0.2         q-0.2 0.0 -0.2 0.2         q-0.0 -0.2 -0.2 -0.2         q0.2 0 0.2 -0.2       "
  }), /*#__PURE__*/React.createElement("path", {
    id: "star-small",
    fill: "#fff",
    d: "         M0 -0.1         q0 0.1 0.1 0.1         q-0.1 0.0 -0.1 0.1         q-0.0 -0.1 -0.1 -0.1         q0.1 0 0.1 -0.1       "
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.5,
    ry: 4.5,
    cy: 0.1,
    fill: "url(#cameo-edge)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.3, 0.2)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    transform: "rotate(15) translate(0, -0.8)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    transform: "rotate(45) translate(0, -0.8)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    transform: "rotate(75) translate(0, -0.8)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    transform: "rotate(105) translate(0, -0.8)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    transform: "rotate(135) translate(0, -0.8)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    transform: "rotate(165) translate(0, -0.8)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    transform: "rotate(-15) translate(0, -0.8)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    transform: "rotate(-45) translate(0, -0.8)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    transform: "rotate(-75) translate(0, -0.8)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    transform: "rotate(-105) translate(0, -0.8)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    transform: "rotate(-135) translate(0, -0.8)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    transform: "rotate(-165) translate(0, -0.8)"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    transform: "translate(-2.3, -0.6)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    transform: "translate(-2.9, 0.3)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    transform: "translate(-2.5, 0.8)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    transform: "translate(-1.5, 0.2)"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    transform: "translate(-2.5, -1.4)"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    transform: "translate(0.6, -3.8)"
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    transform: "translate(0.3, -3.7)"
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    transform: "translate(-0.5, -3.9)"
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    transform: "translate(0.9, -3.4)"
  })), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    transform: "translate(-1.5, -3.3)"
  })), _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    transform: "translate(-2.5, -2.4)"
  })), _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    transform: "translate(2.5, -2.5)"
  })), _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    transform: "translate(2.8, -1.2)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ivory",
    strokeWidth: 0.1,
    d: "       M-0.9 -0.2       q-0.5 1.0 -0.9 1.3       q-0.3 0.1 -0.6 0.5       q-0.1 0.2 -0.2 0.4       q2.6 4 5.2 0       q-1.0 -1 -2.2 -1.3       q-0.1 -0.1 0.2 -1       z     "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "ivory",
    strokeWidth: 0.1,
    d: "       M-1.0 0.0       q0.6 0.3 1.4 0.4     "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "ivory",
    strokeWidth: 0.1,
    d: "       M0 -3       q-0.1 -0.2 -0.3 -0.3       q-1 -0.4 -1.5 1       q-0.3 0.8 0.4 1.8       q0.4 0.5 0.9 0.5       l0.5 -2       z     "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "ivory",
    strokeWidth: 0.1,
    d: "       M0 -3       q1.9 -0.1 2 0       q0 2 -1 3       q-0.1 0.2 -1.5 0       q0.4 -1.5 0.5 -3     "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "ivory",
    strokeWidth: 0.1,
    d: "       M-0.2 -2.7       q-0.5 -0.4 -1.2 0     "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "ivory",
    strokeWidth: 0.1,
    d: "       M-0.3 -2       q-0.75 -0.3 -1.4 0     "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "ivory",
    strokeWidth: 0.1,
    d: "       M-0.5 -1       q-0.5 0.1 -1.0 0     "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontierswomansLeague);
export default __webpack_public_path__ + "static/media/frontierswomans-league.7f44b5953a7ee2db137ac209e1057e60.svg";
export { ForwardRef as ReactComponent };